import { render, staticRenderFns } from "./dispensemedicine.vue?vue&type=template&id=2f890a5b&"
import script from "./dispensemedicine.vue?vue&type=script&lang=js&"
export * from "./dispensemedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports